/*
 * @Author: Tina Huang
 * @Date: 2024-01-23 17:26:05
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-03-21 09:29:55
 * @Description:
 */

import wid from '../assets/svgs/icons/block-one.svg'
import temp from '../assets/svgs/icons/page-template.svg'
import vip from '../assets/svgs/icons/vip.svg'
// import log from '../assets/svgs/icons/log.svg'
import notice from '../assets/svgs/icons/communication.svg'
import balance from '../assets/svgs/icons/dashboard.svg'
import qaIcon from '../assets/svgs/icons/lightning.svg'
import ObsidianIcon from '@/assets/svgs/obsidian'

type NAV_ITEM_TYPE = {
  name: string
  key: string
  path: string
  logo: any
  desc?: string
  update?: boolean
  update_msg?: string
}

export const HOME_NAV: NAV_ITEM_TYPE[] = [
  {
    name: '组件',
    key: 'libs',
    path: '/libs',
    logo: '🧩',
  },
  {
    name: '模板',
    key: 'picks',
    path: '/picks',
    logo: '📁',
  },
  {
    name: '订阅',
    key: 'vips',
    path: '/vips',
    logo: '👑',
  },
  // {
  //   name: '小票生成器',
  //   key: 'receipt-creator',
  //   path: '/receipt-creator',
  //   logo: '🧾',
  // },
  // {
  //   name: '赞助',
  //   key: 'likes',
  //   path: '/likes',
  //   logo: '❤️',
  // },
  {
    name: '问答社区',
    key: 'feedback',
    path: '/qa',
    logo: '❓',
  },
  // {
  //   name: 'Obsidian',
  //   key: 'obsidian',
  //   path: '/obsidian',
  //   logo: ObsidianIcon(),
  // },
]

export const NAV_MENU: NAV_ITEM_TYPE[] = [
  {
    name: '组件',
    key: 'libs',
    path: '/libs',
    logo: wid,
    desc: '个性化自定义组件 / 无个数限制，支持嵌入Notion，Wolai，FlowUs等笔记软件',
  },
  {
    name: '模板',
    key: 'picks',
    path: '/picks',
    logo: temp,
    desc: '本站模板为Notion和FlowUs模板，旨在高效构建个人体系，点击「立即体验」寻找你想要的模板吧',
  },
  // {
  //   name: '小世界',
  //   key: 'world',
  //   path: '/world',
  //   logo: '🌍',
  // },
  {
    name: '订阅',
    key: 'vips',
    path: '/vips',
    logo: vip,
    desc: '为方便大家快捷订阅所有模板，支持开通永久订阅所有模板，「特惠」活动正在进行中',
  },
  {
    name: '挑战',
    key: 'balance',
    path: '/how-to-balance',
    logo: balance,
    desc: '在这里我将开展督促挑战打卡栏目（包括减肥，学习等），可以一起快乐自律！',
    update: true,
    update_msg: '💪 新挑战',
  },
  // {
  //   name: '日志',
  //   key: 'logs',
  //   path: '/logs',
  //   logo: log,
  //   desc: '在这里你可以看到本站所有更新记录',
  // },
  {
    name: '公告',
    key: 'notices',
    path: '/notices',
    logo: notice,
    desc: '在这里你可以了解到所有的重要信息，如模板更新，教程发布等等',
  },
  {
    name: '问答',
    key: 'feedback',
    path: '/qa',
    logo: qaIcon,
    desc: '在这里我将会放置一些Notion以及FlowUs使用的问题解答，后续也将开展Formula（公式应用）专题',
  },
]
